export default __webpack_public_path__ + "static/media/handler.925dbf39.svg";